import { useState, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header/Header';
import MyAthletesPanel from '../components/MyAthletesPanel/MyAthletesPanel';
import Watermark from '../components/Watermark/Watermark';

const DashboardLayout = () => {
  const dashboardRef = useRef();
  const [showMyAthletesPanel, setShowMyAthletesPanel] = useState(false);
  const [selectedAthlete, setSelectedAthlete] = useState(null);

  return (
    <div ref={dashboardRef}>
      <Watermark />
      <Header onOpenAthletesPanel={() => setShowMyAthletesPanel(true)} />
      <main>
        <Outlet context={{
          dashboardRef,
          openMyAthletesPanel: () => setShowMyAthletesPanel(true),
          setSelectedAthlete,        
          selectedAthlete,
          clearSelectedAthlete: () => setSelectedAthlete(null)        
        }} />
      </main>
      <MyAthletesPanel
        isOpen={showMyAthletesPanel}
        onClose={() => setShowMyAthletesPanel(false)}
        onAthleteSelect={(athlete) => {
          setSelectedAthlete(athlete);       
          setShowMyAthletesPanel(false);     
        }}
        selectedAthlete={selectedAthlete} 
        clearSelectedAthlete={() => setSelectedAthlete(null)}
      />
    </div>
  );
};

export default DashboardLayout;